import {
  Divider,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";

import React from "react";
import { get } from "lodash";
import moment from "moment";

import { useTranslate } from "react-admin";

const UsersField = (props) => {
  const translate = useTranslate();

  const { resource, record, source } = props;
  const records = get(record, source, []);
  if (records.length === 0) {
    return null;
  }
  const dateFormat = translate("app.date_format.long");
  return (
    <div>
      <Typography variant="subtitle1">
        {translate(`resources.${resource}.fields.${source}`)}
      </Typography>
      <Divider />
      <Typography variant="body1">
        {translate(`resources.${resource}.fields.${source}.help`)}
      </Typography>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>
              {translate(`resources.${resource}.fields.${source}.name`)}
            </TableCell>
            <TableCell>
              {translate(`resources.${resource}.fields.${source}.roles`)}
            </TableCell>
            <TableCell>
              {translate(`resources.${resource}.fields.${source}.created`)}
            </TableCell>
            <TableCell>
              {translate(`resources.${resource}.fields.${source}.deleted`)}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {records.map((record) => (
            <TableRow key={record.id}>
              <TableCell>{get(record, "user.name")}</TableCell>
              <TableCell>
                {get(record, "user.roles", [])
                  .map((r) => get(r, "name"))
                  .join(", ")}
              </TableCell>
              <TableCell>
                {moment(get(record, "created")).format(dateFormat)}
              </TableCell>
              <TableCell>
                {get(record, "deleted", null) !== null &&
                  moment(get(record, "deleted")).format(dateFormat)}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <br />
    </div>
  );
};

export default UsersField;
